import { useCallback, useEffect, useRef } from 'react';
/**
 * Converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop and exposed as a stable function to avoid executing effects when
 * passed as a dependency.
 */
function createStableCallbackHook(useEffectHook, callback) {
    let callbackRef = useRef(callback);
    useEffectHook(() => {
        callbackRef.current = callback;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(((...args) => {
        callbackRef.current && callbackRef.current(...args);
    }), []);
}
/**
 * Converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop and exposed as a stable function to avoid executing effects when passed
 * as a dependency.
 */
export function useStableCallback(callback) {
    return createStableCallbackHook(useEffect, callback);
}
//# sourceMappingURL=callback.js.map